import Vue from "vue"
import VueProgressBar from "vue-progressbar"

Vue.use(VueProgressBar, {
  color: "#FFF907",
  failedColor: "red",
})
